import { createContext } from 'react';

export const AlertDrawerContext = createContext({
  onOpenAlertDrawer: (_siteId?: number) => {
    console.log(_siteId);
  },
  tenantAlertsCount: 0,
  isAlertsLoaded: false,
});
